import React, {useEffect, useState} from 'react';
import ReactDOM from 'react-dom';
import reportWebVitals from './reportWebVitals';
import '~/assets/scss/main.scss';
import rootStore, {AppDispatch} from '~/redux/root-store';
import {initSentry} from '~/services/sentry';
import {publicRoutes} from '~/routes';
import config from '~/config/app-config';
import {getCurrentUserFromStorage, saveUserCredential} from '~/services/auth';
import {RootState} from '~/redux/root-reducer';
import {Provider, useDispatch} from 'react-redux';
import {AppRouter, UiPageLoading} from '~/components/elements';
import {ignoreLogs} from '~/services/ignore-logs';
import {ChakraProvider, ColorModeScript} from '@chakra-ui/react';
import {uiTheme} from '~/theme/chakra-theme';
import {setTokenRequestHeader} from './utils/request';
import NotFoundPage from './pages/not-found';
import {setIsWebview, setMethodKey} from '~/redux/questionnaires/slice';
const queryString = require('query-string');
import '@fontsource/inter/400.css';
import '@fontsource/inter/500.css';
import '@fontsource/inter/600.css';
import '@fontsource/inter/700.css';
import {initGA} from '~/services/google-analytics';

ignoreLogs();

initSentry();
initGA();

const Root = () => {
  return (
    <Provider store={rootStore}>
      <ChakraProvider theme={uiTheme}>
        <App />
      </ChakraProvider>
    </Provider>
  );
};

interface Params {
  methodKey: string;
  token: string;
  isWebview?: boolean;
}

const App = () => {
  const dispatch: AppDispatch = useDispatch();
  const [isInitializing, setIsInitializing] = useState(true);
  const location = window.location;
  const query: Params = queryString.parse(location.search);

  useEffect(() => {
    const init = async () => {
      const {accessToken: savedToken} = getCurrentUserFromStorage();
      if (!query?.token) {
        setTokenRequestHeader(undefined);
      } else {
        const token = query?.token || savedToken || '';
        await dispatch(setMethodKey({key: query?.methodKey || ''}));
        dispatch(setIsWebview({data: query.isWebview || false}));
        await saveUserCredential({accessToken: token});
        setTokenRequestHeader(token);
      }
      setIsInitializing(false);
    };
    init();
  }, [dispatch, query.methodKey, query.token, query.isWebview]);

  if (isInitializing) {
    return <UiPageLoading />;
  }

  return <AppRouter basename={config.routeBaseName} publicRoutes={publicRoutes} defaultRedirect="/" />;
};

ReactDOM.render(
  <React.StrictMode>
    <ColorModeScript initialColorMode={uiTheme.config.initialColorMode} />
    <Root />
  </React.StrictMode>,
  document.getElementById('root'),
);

reportWebVitals();
